import { useTranslator } from "components/Translator"
import { ForumPage } from "components/ForumPage"
import { Section } from "components/Section"
import { ForumTagCard } from "domains/forum-tag/ForumTagCard"
import { Fragment } from "react"
import { ForumPostsList } from "domains/forum-post/ForumPostsList"
import { PromoBanner } from "components/PromoBanner"

export function ClubForumIndexPage(props) {
  const translator = useTranslator()

  return (
    <>
      <PromoBanner />
      <ForumPage
        metrics={props.metrics}
        formSearch={props.formSearch}
        title={translator.trans("club.forum.index.title", null, "pages")}
        main={
          <Main posts={props.posts} replies={props.replies} tags={props.tags} />
        }
      />
    </>
  )
}

const Main = (props) => {
  const translator = useTranslator()

  return (
    <Fragment>
      <Section aria-labelledby={"posts-title"}>
        <Section.Title id={"posts-title"}>
          {translator.trans("club.forum.index.posts.title", null, "pages")}
        </Section.Title>
        <ForumPostsList posts={props.posts} />
      </Section>

      <Section aria-labelledby={"replies-title"}>
        <Section.Title id={"replies-title"}>
          {translator.trans("club.forum.index.replies.title", null, "pages")}
        </Section.Title>
        <ForumPostsList posts={props.replies} />
      </Section>

      <Section aria-labelledby={"tags-title"}>
        <Section.Title id={"tags-title"}>
          {translator.trans("club.forum.index.tags.title", null, "pages")}
        </Section.Title>

        <ul className={"grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4"}>
          {props.tags.map((tag) => {
            return (
              <li key={tag.id} aria-label={tag.title}>
                <ForumTagCard tag={tag} />
              </li>
            )
          })}
        </ul>
      </Section>
    </Fragment>
  )
}
